import { useSelector } from 'react-redux';
import { LayoutType, WaveType } from 'signup-components/types';
import { useSignupEmbedder } from 'signup-embedder/hooks/useSignupEmbedder';
import { getFlowConfig } from '../flow-initial/getFlowConfig';
import { useMessage } from '../messaging/useMessage';
import { getActiveError } from '../store/error/selectors';
import { getPostAccountCreationSteps } from '../store/flow/selectors';
import { Step } from '../views/Step';
import { getStepConfig } from '../views/getStepConfig';
import { useCurrentStep } from './useCurrentStep';
import { getActiveLoading } from '../store/loading-status/selectors';
import { isInACQ142VariantAMSS } from '../experiments/gswhV1/gswhUtils';
export const getWaveType = ({
  currentStep,
  postAccountCreationSteps,
  activeLoading
}) => {
  const stepConfig = getStepConfig(currentStep);
  const isPostAccountCreationStep = postAccountCreationSteps.includes(currentStep);

  if (activeLoading || !stepConfig) {
    return undefined;
  }

  if (isPostAccountCreationStep && getFlowConfig().shouldUseWaveOnPostAccountCreation || currentStep === Step.InstallSalesExtension) {
    return WaveType.LowOrange;
  }

  return stepConfig.waveType;
};
export const useLayoutTemplate = () => {
  const postAccountCreationSteps = useSelector(getPostAccountCreationSteps);
  const {
    currentStep
  } = useCurrentStep();
  const activeError = useSelector(getActiveError);
  const step = activeError || currentStep;
  const stepConfig = getStepConfig(step);
  const {
    isActive: isInstanceOfSignupEmbedder
  } = useSignupEmbedder();
  const showMessagingAboveContent = stepConfig && stepConfig.showMessagingAboveContent;
  const {
    shouldDisplayMessaging
  } = useMessage();
  const layoutType = shouldDisplayMessaging && !showMessagingAboveContent ? LayoutType.TwoColumn : getFlowConfig().getLayoutType();
  const activeLoading = useSelector(getActiveLoading);
  const waveType = getWaveType({
    currentStep,
    activeError,
    postAccountCreationSteps,
    activeLoading
  });
  const isPostAccountCreationStep = postAccountCreationSteps.includes(currentStep);
  const shouldShowProgressBar = !activeError && stepConfig && stepConfig.stepKey && !stepConfig.hideProgressBar;
  const isACQ142VariantAMSS = useSelector(isInACQ142VariantAMSS);

  if (activeLoading) {
    return {
      layoutType: LayoutType.CentredStep,
      waveType,
      shouldShowProgressBar
    };
  }

  if (isACQ142VariantAMSS && isPostAccountCreationStep) {
    return {
      layoutType: LayoutType.FramedCentredStep,
      waveType,
      shouldShowProgressBar
    };
  }

  if (isPostAccountCreationStep && !isInstanceOfSignupEmbedder) {
    return {
      layoutType,
      waveType,
      shouldShowProgressBar
    };
  }

  return {
    layoutType,
    waveType,
    shouldShowProgressBar
  };
};